export default "__VITE_ASSET__Coqybb9J__"